import api, { endpoints } from '@utils/api';

export const getActiveRoles = async () => {
  try {
    const response = await api.get(endpoints.activeRoles);
    return response.data.data; 
  } catch (error) {
    throw error;
  }
};

export const getActiveCompanyRoles = async (params = {}) => {
  try {
    const response = await api.get(endpoints.activeCompanyRoles, {
      params: {
        page: params.page || 1,
        pageSize: params.pageSize || 100,
        search: params.search || '',
        is_active: params.is_active,
        ...params
      }
    });
    return response.data.data; 
  } catch (error) {
    throw error;
  }
};

export const createCompanyRole = async (roleData) => {
  try {
    const response = await api.post(`${endpoints.companyRoles}/create`, roleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyRole = async (roleId, roleData) => {
  try {
    const response = await api.put(`${endpoints.companyRoles}/update/${roleId}`, roleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyRole = async (roleId) => {
  try {
    const response = await api.delete(`${endpoints.companyRoles}/delete/${roleId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCompanyRole = async (roleId) => {
  try {
    const response = await api.get(`${endpoints.companyRoles}/get/${roleId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const listCompanyRoles = async (params = {}) => {
  try {
    // Build clean params object, only including defined values
    const cleanParams = {
      page: params.page || 1,
      pageSize: params.pageSize || 20,
    };

    // Only add search if it has a value
    if (params.search && params.search.trim()) {
      cleanParams.search = params.search.trim();
    }

    // Only add is_active if it's defined
    if (params.is_active !== undefined) {
      cleanParams.is_active = params.is_active;
    }

    // Add role_names if provided
    if (params.role_names) {
      cleanParams.role_names = params.role_names;
    }

    // Add levels if provided
    if (params.levels) {
      cleanParams.levels = params.levels;
    }

    const response = await api.get(endpoints.companyRoles, { 
      params: cleanParams
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const selectRole = async (roleId) => {
  try {
    const response = await api.post(endpoints.selectRole, { role_id: roleId });
    return response.data;
  } catch (error) {
    throw error;
  }
};